var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"label":"Ethnicity","loading":_vm.loading,"items":_vm.ethnicities,"color":_vm.themes.candidate.light.input,"menu-props":{ offsetY: true },"attach":""},on:{"input":_vm.submit},model:{value:(_vm.profile.ethnicity),callback:function ($$v) {_vm.$set(_vm.profile, "ethnicity", $$v)},expression:"profile.ethnicity"}})
}
var staticRenderFns = []

export { render, staticRenderFns }